import React from "react";
import PropTypes from "prop-types";

/**
 * App 層錯誤邊界:任一頁 render 出錯時,顯示友善 fallback(而非整個 app 白屏)。
 * 原始錯誤 console.error 保留給開發者。
 */
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "test") {
      // eslint-disable-next-line no-console
      console.error("[App error]", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
          <div className="text-center text-muted">
            <i className="mdi mdi-alert-circle-outline text-danger" style={{ fontSize: 56 }} />
            <h4 className="mt-3">系統發生非預期錯誤</h4>
            <p className="mb-3">請重新整理頁面;若問題持續,請聯繫系統管理者。</p>
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              重新整理
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
AppErrorBoundary.propTypes = { children: PropTypes.node };

export default AppErrorBoundary;
